<main 
  id="geolocation-description"
  class="geolocation-request__main"
>
  <p class="ci-paragraph-p1-regular geolocation-request__helper-text">
    {{ 'Para poder seguir tu ruta en tiempo real solicitaremos los permisos de geolocalización. En caso de no aceptarlos, se realizará una navegación paso a paso' | translate }}
  </p>
  <p class="ci-paragraph-p1-regular geolocation-request__helper-text">
    <strong>
      {{ 'Esta acción es necesaria para actividades de gamificación' | translate }}
    </strong>
  </p>
</main>